
import { ViewModelFiltraCobranca } from './../shared/models/viewModelFiltraCobranca.model';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { AfterViewInit, Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { MatDatepicker, MatPaginator, MatSnackBar, MatSort, MatTableDataSource, Sort } from '@angular/material';
import { Router } from '@angular/router';
import { CdkDetailRowDirective } from '../shared/directives/cdk-detail-row.directive';
import { Contribuicao } from '../shared/models/contribuicao.model';
import { Plano } from '../shared/models/plano.model';
import { ContribuicaoService } from '../shared/services/contribuicao.service';
import { PlanoService } from '../shared/services/plano.service';
import { EmpresaService } from '../shared/services/empresa.service';
import { Empresa } from '../shared/models/empresa.model';
import { ModoLiquidacaoService } from '../shared/services/modoLiquidacao.service';
import { ModoLiquidacao } from '../shared/models/modoLiquidacao.model';
import { FormControl } from '@angular/forms';
import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports
import { default as _rollupMoment, Moment } from 'moment';
import { WebCobrancaService } from '../shared/services/webCobranca.service';
import { ViewModelRetornaCobrancaSintetica } from '../shared/models/viewModelRetornaCobrancaSintetica.model';

import { ViewModelRetornoCobranca } from '../shared/models/viewModelRetornoCobranca.model';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { ModuloTpwCobranca } from '../shared/models/moduloTpwCobranca.model';
import _ from 'lodash';

interface Modulo {
    nome: string;
    idModulo: number;
}

@Component({
    selector: 'app-relatorio-cobranca',
    templateUrl: './relatorio-cobranca.component.html',
    styleUrls: ['./relatorio-cobranca.component.scss'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
})


export class RelatorioCobrancaComponent implements OnInit, AfterViewInit {
    lista_Plano: Plano[] = [];
    contribuicao: Contribuicao[] = [];
    empresa: Empresa[] = [];
    modoLiquidacao: ModoLiquidacao[] = [];
    listaViewModelRetornaCobrancaSintetica: ViewModelRetornaCobrancaSintetica[] = [];
    dataSource = new MatTableDataSource(this.listaViewModelRetornaCobrancaSintetica);
    dataSource2 = new MatTableDataSource<any>();
    displayedColumns: string[] = ['dataVencimento', 'nmPlano', 'nmEmpresa','vlTotal', 'acao'];
    displayedColumns2: string[] = ['nome', 'cpf', 'vencimento', 'pagamento','competencia','cancelamento', 'valor', 'modulo', 'acao'];
    viewModelRetornaCobrancaSintetica: ViewModelRetornaCobrancaSintetica[] = [];
    viewModelFiltraCobranca: ViewModelFiltraCobranca = new ViewModelFiltraCobranca();
    viewModelFiltraCobrancaDetalhes: ViewModelFiltraCobranca = new ViewModelFiltraCobranca();
    listaViewModelRetornoCobranca: ViewModelRetornoCobranca[] = [];
    listaModulos: ModuloTpwCobranca[] = [];
    viewModelFiltraCobrancaDetalhesTeste: ViewModelFiltraCobranca = new ViewModelFiltraCobranca();
    loading = false;
    sortedData: ViewModelRetornaCobrancaSintetica[];
    private paginator1: MatPaginator;
    private paginator2: MatPaginator;

    @ViewChild(MatSort, { static: true }) sort: MatSort;

    @ViewChild('paginatorA', { static: true }) set paginatorA(mp: MatPaginator) {
        this.paginator1 = mp;
        this.setDataSourceAttributes();
    }

    @ViewChild('paginatorB', { static: false }) set paginatorB(mp: MatPaginator) {
        this.paginator2 = mp;
        this.setDataSourceAttributes();
    }
    ngAfterViewInit() {
        this.dataSource.sort = this.sort;
    }
    setDataSourceAttributes() {
        // this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator1;
        this.dataSource2.paginator = this.paginator2;
    }


    private openedRow: CdkDetailRowDirective;
    constructor(private planoService: PlanoService,
        private contribuicaoService: ContribuicaoService,
        private webCobrancaService: WebCobrancaService,
        private _liveAnnouncer: LiveAnnouncer,
        private readonly router: Router,
        private _snackBar: MatSnackBar,
        private empresaService: EmpresaService,
        private modoLiquidacaoService: ModoLiquidacaoService,) {
        this.loadPlano();
        this.loadContribuicao();
        this.loadEmpresa();
        this.loadModoLiquidacao();
        this.loadModulos();

        let obj = JSON.parse(localStorage.getItem('searchCobranca'));

        if (obj != null) {
            this.viewModelFiltraCobranca = obj;
            this.filtroCobranca();
        }

    }

    ngOnInit() {
    }

    loadPlano() {
        this.planoService.getAll().subscribe(plano => {
            this.lista_Plano = plano;
        })
    }
    stop(event: UIEvent) {
        event.stopPropagation();
    }

    sortData(sort: Sort) {
        const data = this.dataSource.data.slice();
        if (!sort.active || sort.direction === '') {
            this.sortedData = data;
            return;
        }

        this.sortedData = data.sort((a, b) => {
            const isAsc = sort.direction === 'asc';
            switch (sort.active) {
                case 'nmPlano':
                    return this.compare(a.nmPlano, b.nmPlano, isAsc);
                case 'nmEmpresa':
                    return this.compare(a.nmEmpresa, b.nmEmpresa, isAsc);
                case 'dataVencimento':
                    return this.compare(a.dataVencimento, b.dataVencimento, isAsc);
                case 'vlTotal':
                    return this.compare(a.vlTotal, b.vlTotal, isAsc);
                    
                default:
                    return 0;
            }
        });
    }
    compare(a: number | string, b: number | string, isAsc: boolean) {
        return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
    }
    onToggleChange(cdkDetailRow: CdkDetailRowDirective): void {
        if (this.openedRow && this.openedRow.expended) {
            this.openedRow.toggle();
        }
        this.openedRow = cdkDetailRow.expended ? cdkDetailRow : undefined;
    }
    verDetalhe(element: any): void {
        localStorage.setItem('detalheCobranca', JSON.stringify(element));
        localStorage.setItem('searchCobranca', JSON.stringify(this.viewModelFiltraCobranca));
        localStorage.setItem('searchDataCobranca', JSON.stringify(this.dataSource.data));
        this.router.navigate(["/detalhesCobranca", element], { skipLocationChange: true });

    }

    clear() {
        this.viewModelFiltraCobranca = new ViewModelFiltraCobranca();
        this.dataSource.data = [];
        this.dataSource2.data = [];
    }

    filtroCobranca() {
        this.loading = true;
        var result = this.isEmpty(this.viewModelFiltraCobranca);
        if (result) {
            this.openSnackBar("Informe pelo menos um parâmetro para realizar a busca!", 'X');
            this.loading = false;
        }
        else if (this.viewModelFiltraCobranca.idModulo === undefined) {
            this.openSnackBar("Informe o módulo para realizar a busca!", 'X');
            this.loading = false;
        }
        else if (this.viewModelFiltraCobranca.dtVencInicio === undefined || this.viewModelFiltraCobranca.dtVencFim === undefined) {
            this.openSnackBar("Informe a data de vencimento para realizar a busca!", 'X');
            this.loading = false;
        }
        else {

            if (this.viewModelFiltraCobranca.icQuitacao)
                this.viewModelFiltraCobranca.icQuitacao = this.viewModelFiltraCobranca.icQuitacao.toString();
            else
                this.viewModelFiltraCobranca.icQuitacao = undefined;

            if (this.viewModelFiltraCobranca.icAntecipacao)
                this.viewModelFiltraCobranca.icAntecipacao = this.viewModelFiltraCobranca.icAntecipacao.toString();
            else
                this.viewModelFiltraCobranca.icAntecipacao = undefined;

            if (this.viewModelFiltraCobranca.icInadimplente)
                this.viewModelFiltraCobranca.icInadimplente = this.viewModelFiltraCobranca.icInadimplente.toString();
            else
                this.viewModelFiltraCobranca.icInadimplente = undefined;

            if (this.viewModelFiltraCobranca.icRegistrado)
                this.viewModelFiltraCobranca.icRegistrado = this.viewModelFiltraCobranca.icRegistrado.toString();
            else
                this.viewModelFiltraCobranca.icRegistrado = undefined;

            if (this.viewModelFiltraCobranca.icLiberado)
                this.viewModelFiltraCobranca.icLiberado = this.viewModelFiltraCobranca.icLiberado.toString();
            else
                this.viewModelFiltraCobranca.icLiberado = undefined;

            if (this.viewModelFiltraCobranca.icCalculado)
                this.viewModelFiltraCobranca.icCalculado = this.viewModelFiltraCobranca.icCalculado.toString();
            else
                this.viewModelFiltraCobranca.icCalculado = undefined;

            if (this.viewModelFiltraCobranca.icPrestacao)
                this.viewModelFiltraCobranca.icPrestacao = this.viewModelFiltraCobranca.icPrestacao.toString();
            else
                this.viewModelFiltraCobranca.icPrestacao = undefined;

            this.webCobrancaService.filtraCobrancaSintetica(this.viewModelFiltraCobranca).subscribe(retorno => {
                if (retorno) {
                    if (retorno.length === 0) {
                        this.openSnackBar("A Pesquisa não encontrou resultados!", 'X');
                    }
                    this.dataSource.data = _.orderBy(retorno, ['dataVencimento', 'nmPlano', 'nmEmpresa'], ['asc', 'asc', 'asc']);
                    console.log('teste', this.dataSource.data);
                    // this.listaViewModelRetornaCobrancaSintetica = retorno;
                    this.loading = false;
                }
            }, error => {
                this.loading = false;
                this.openSnackBarError("Erro ao realizar a busca!" + error, 'X');
            });
        }

    }

    /* 
        isEquivalent(a, b) {
            // Create arrays of property names
            var aProps = Object.getOwnPropertyNames(a);
            var bProps = Object.getOwnPropertyNames(b);
    
            // If number of properties is different,
            // objects are not equivalent
            if (aProps.length != bProps.length) {
                return false;
            }
    
            for (var i = 0; i < aProps.length; i++) {
                var propName = aProps[i];
    
                // If values of same property are not equal,
                // objects are not equivalent
                if (a[propName] !== b[propName]) {
                    return false;
                }
            }
    
            // If we made it this far, objects
            // are considered equivalent
            return true;
        } */

    // Outputs: true
    //console.log(isEquivalent(bobaFett, jangoFett));




    openSnackBar(message: string, action: string) {
        this._snackBar.open(message, action, {
            duration: 20000,
            panelClass: ['mat-toolbar', 'mat-success']
        });
    }

    openSnackBarError(message: string, action: string) {
        this._snackBar.open(message, action, {
            duration: 20000,
            panelClass: ['mat-toolbar', 'mat-warn']
        });
    }
    loadContribuicao() {
        this.contribuicaoService.getAll().subscribe(retorno => {
            this.contribuicao = retorno;
        });
    }

    loadEmpresa() {
        this.empresaService.getAll().subscribe(retorno => {
            this.empresa = retorno;
        });
    }

    loadModoLiquidacao() {
        this.modoLiquidacaoService.getAll().subscribe(retorno => {
            this.modoLiquidacao = retorno;
        });
    }

    loadModulos() {
        this.webCobrancaService.filtraModuloCobranca().subscribe(retorno => {
            this.listaModulos = retorno;
        }, error => {
            this.loading = false;
            this.openSnackBarError("Erro ao carregar os módulos!" + error, 'X');
        });
    }


    isEmpty(obj: ViewModelFiltraCobranca) {
        for (var prop in obj) {
            if (obj[prop] != "")
                return false;
        }
        return true;


    };

    carregaDetalhesCobranca(element: ViewModelRetornaCobrancaSintetica) {
        console.log('teste aqui', element);
        element.dtCompetencia = new Date(element.nrAnoComp, element.nrMesComp).toDateString();
        console.log('COMPETENCIA', element.dtCompetencia)
        // element.dtCompetencia = element.NrMesComp +"/"+element.NranoComp;
        // console.log(element.dtCompetencia)
        console.log(this.openedRow);

        // if (!this.openedRow) {
        this.loading = true;

        //parâmetros obrigatorios
        this.viewModelFiltraCobrancaDetalhes.idEmp = element.idEmp;
        this.viewModelFiltraCobrancaDetalhes.idPlano = element.idPlano;
        this.viewModelFiltraCobrancaDetalhes.dtVencInicio = element.dataVencimento;
        this.viewModelFiltraCobrancaDetalhes.dtVencFim = element.dataVencimento;
         this.viewModelFiltraCobranca.dtCompetencia = element.dtCompetencia

        //passar os outros parâmetros aqui

        this.viewModelFiltraCobrancaDetalhes.cpf = this.viewModelFiltraCobranca.cpf;
        this.viewModelFiltraCobrancaDetalhes.idModulo = this.viewModelFiltraCobranca.idModulo;       
        this.viewModelFiltraCobrancaDetalhes.dtPagInicio = this.viewModelFiltraCobranca.dtPagInicio;
        this.viewModelFiltraCobrancaDetalhes.dtPagFim = this.viewModelFiltraCobranca.dtPagFim;
        this.viewModelFiltraCobrancaDetalhes.dtCancInicio = this.viewModelFiltraCobranca.dtCancInicio;
        this.viewModelFiltraCobrancaDetalhes.dtCancFim = this.viewModelFiltraCobranca.dtCancFim;
        this.viewModelFiltraCobrancaDetalhes.idContribuicao = this.viewModelFiltraCobranca.idContribuicao;
        this.viewModelFiltraCobrancaDetalhes.idModoLiquidacao = this.viewModelFiltraCobranca.idModoLiquidacao;
        this.viewModelFiltraCobrancaDetalhes.valorIninico = this.viewModelFiltraCobranca.valorIninico;
        this.viewModelFiltraCobrancaDetalhes.valorFim = this.viewModelFiltraCobranca.valorFim;
        this.viewModelFiltraCobrancaDetalhes.dtRefFim = this.viewModelFiltraCobranca.dtRefFim;

        console.log('viewModelFiltraCobrancaDetalhes', this.viewModelFiltraCobrancaDetalhes)

        this.webCobrancaService.filtraCobranca(this.viewModelFiltraCobrancaDetalhes).subscribe(retorno => {
            console.log('teste da tabela2', retorno)
            this.dataSource2.data = retorno;
            //this.listaViewModelRetornoCobranca = retorno;  

            this.loading = false;
        }, error => {
            this.loading = false;
            this.openSnackBarError("Erro ao realizar a busca!" + error, 'X');
        });
    }
    // }

}
